<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-06-26 12:17:42
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-07-09 13:42:15
 * @FilePath: \大屏项目\src\components\designer\e-collapse.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="border: 1px solid var(--td-font-gray-4);margin-bottom: 4px;border-radius: 4px;background-color: rgba(218,218,218,0.04)">
    <div @click="clickHandle" style="position: relative;color: var(--td-text-color-primary);line-height: 35px;background-color: var(--td-font-gray-4);cursor:pointer;">
      <div style="text-indent: 1em">{{title}}</div>
      <div style="position: absolute;right: 6px;top: 0">
        <t-icon :name="expanded ? 'chevron-down':'chevron-right'"/>
      </div>
    </div>
    <div style="transition: all .2s;overflow: hidden" :style="{maxHeight:expanded ? '1000px':'0px'}">
      <div ref="cusFormItem" style="padding-top: 6px;padding-bottom: 6px;">
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "e-collapse",
  props:{
    expand:{
      type:Boolean,
      default:false
    },
    title:{
      type:String
    }
  },
  data(){
    return {
      expanded:false,
      slotHeight: 0
    }
  },
  created() {
    this.expanded = this.expand
  },
  methods:{
    clickHandle(){
      this.expanded = !this.expanded
    }
  }
}
</script>

<style scoped>
</style>
